// extracted by mini-css-extract-plugin
export default {"addressSection":"gT-z","disabled":"hT-z","sectionButtons":"iT-z","logo":"jT-z"};